import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Slide, toast, ToastContainer } from "react-toastify";
import { useNotificationContext } from "providers/NotificationProvider";

const shownNotificationIds = new Set<number>();

export const NotificationToasts = () => {
  const { newestNotifications } = useNotificationContext();
  const [toastPosition, setToastPosition] = useState({ right: 0, top: 0 });
  const navigate = useNavigate();

  const anchorRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      const rect = node.getBoundingClientRect();
      setToastPosition({ right: rect.right, top: rect.top });
    }
  }, []);

  useEffect(() => {
    if (!newestNotifications?.length) return;

    const notifications = newestNotifications as unknown as Array<{
      id: number;
    }>;
    const newNotifications = notifications.filter(
      (n) => !shownNotificationIds.has(n.id)
    );
    if (newNotifications.length > 0) {
      toast.info(
        `You have ${newNotifications.length} new notification${newNotifications.length > 1 ? "s" : ""}`,
        {
          containerId: "notification-toast",
          onClick: () => {
            navigate("/notifications");
          }
        }
      );

      newNotifications.forEach((n) => shownNotificationIds.add(n.id));
    }
  }, [newestNotifications, navigate]);

  return (
    <div className="px-4">
      <div ref={anchorRef} />
      <ToastContainer
        position="top-left"
        containerId="notification-toast"
        stacked
        hideProgressBar
        style={{
          padding: "16px",
          borderRadius: "8px",
          fontSize: "14px",
          left: `${toastPosition.right}px`,
          top: `${toastPosition.top}px`
        }}
        transition={Slide}
        className="toast-container no-print fixed cursor-pointer"
        autoClose={2500}
        theme="colored"
      />
    </div>
  );
};
